import Cookies from 'universal-cookie';
const cookies = new Cookies();
const Auth = {
  getAuth() {
    // if(cookies.get('%tokenExpiry%') )
    return !!cookies.get('rushToken');
  },

  saveToken(jwt) {
    return cookies.set('rushToken', jwt);
  },

  getToken() {
    let token = cookies.get('rushToken', { doNotParse: false });
    if (!!token) {
      return {
        Authorization: `Bearer ${token}`,
      }
    } else {
      return {}
    }

  },

  saveUser(user) {
    return cookies.set('user', JSON.stringify(user));
  },

  getUser() {
    return cookies.get('user', { doNotParse: false });
  }
}

export default Auth
